import './styles.scss';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import DialogExportTransactions from './dialog';
import l from '../../../../lang';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/file-download.svg';
import { segmentTransactionsDownloadReport } from '../../../../utils/analytics';
import { useSplitPayments } from '../../../../store/split-payments';
import { SplitPayment } from '../../../../store/split-payments/interfaces';

const ExportTransactions = ({ splitData }: { splitData: SplitPayment }) => {
  const { showExportSplits } = useSplitPayments();
  return (
    <>
      <DialogExportTransactions splitData={splitData} />
      <div className="export_splits__top_button">
        <ButtonCustom
          text={<span className="export_splits__top_button__text">{l('exportTransactions.title')}</span>}
          onClick={() => {
            segmentTransactionsDownloadReport();
            showExportSplits(true);
          }}
          variant="outlined"
          startIcon={<DownloadIcon className="export_splits__top_button__icon" />}
          fullWidth
        />
      </div>
    </>
  );
};

export default ExportTransactions;
